import { render, staticRenderFns } from "./TemplatePreview.vue?vue&type=template&id=9e047c70&"
import script from "./TemplatePreview.vue?vue&type=script&lang=ts&"
export * from "./TemplatePreview.vue?vue&type=script&lang=ts&"
import style0 from "./TemplatePreview.vue?vue&type=style&index=0&id=9e047c70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports